module.exports = __webpack_public_path__ + "img/05.2c6110ef.png";